import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import FeedbackAreaTitle from './FeedbackAreaTitle';
import PlusBlue from '../../static/img/Plus-blue.svg';
import {
  FeedbackAreasWrapper,
  FeedbackAreasContainer,
  FeedbackAreasScrollable,
  PlusImage,
  DragHandle,
  ContentWrapper,
  NewFeedbackAreaButton,
  NewFeedbackAreaText,
  DraggableContainerStyled,
} from './feedbackAreastyle';

const FeedbackAreasDragDrop = ({
  smartComments,
  currentSmartCommentId,
  handleSmartCommentSelection,
  UpdateSmartAnotationHandler,
  createSmartAnnotation,
  deleteAnnotationHandler,
  reorderSmartCommentsHandler,
  canEdit,
  createSmartAnnotationHandler,
  hasEmptyPendingComment = false
}) => {
  const handleDragEnd = async (result) => {
    if (!result.destination || !canEdit) return;

    const items = Array.from(smartComments);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    // Send the reordered items directly
    await reorderSmartCommentsHandler(items);
  };

  const getItemId = (item, index) => {
    if (item._id) return item._id;
    if (item.id) return item.id;
    return `feedback-area-${index}`;
  };

  const cleanSmartComments = smartComments?.filter(comment => comment != null) || [];

  const hasEmptyComments = hasEmptyPendingComment || cleanSmartComments.some(
    comment => !comment.suggestions || comment.suggestions.length === 0 ||
    comment.suggestions.some(suggestion => !suggestion?.trim())
  );

  return (
    <FeedbackAreasWrapper>
      <FeedbackAreasScrollable>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="feedback-areas" isDropDisabled={!canEdit}>
            {(provided) => (
              <FeedbackAreasContainer
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {cleanSmartComments.map((smartComment, index) => (
                  <Draggable
                    key={getItemId(smartComment, index)}
                    draggableId={getItemId(smartComment, index)}
                    index={index}
                    isDragDisabled={!canEdit}
                  >
                    {(provided, snapshot) => (
                      <DraggableContainerStyled
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        isDragging={snapshot.isDragging}
                        transform={provided.draggableProps.style?.transform}
                        className={snapshot.isDragging ? 'dragging' : ''}
                        selected={index === currentSmartCommentId}
                        showPopUp={false}
                      >
                        {canEdit && (
                          <DragHandle {...provided.dragHandleProps} />
                        )}
                        <ContentWrapper>
                          <FeedbackAreaTitle
                            index={index}
                            smartComment={smartComment}
                            currentSmartCommentId={currentSmartCommentId}
                            handleSmartCommentSelection={handleSmartCommentSelection}
                            UpdateSmartAnotationHandler={UpdateSmartAnotationHandler}
                            createSmartAnnotation={createSmartAnnotation}
                            deleteAnnotationHandler={deleteAnnotationHandler}
                            canEdit={canEdit}
                          />
                        </ContentWrapper>
                      </DraggableContainerStyled>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </FeedbackAreasContainer>
            )}
          </Droppable>
        </DragDropContext>
      </FeedbackAreasScrollable>
      {canEdit && (
        <NewFeedbackAreaButton
          onClick={() => !hasEmptyComments && createSmartAnnotationHandler()}
          $disabled={hasEmptyComments}
        >
          <PlusImage src={PlusBlue} />
          <NewFeedbackAreaText>
            New Feedback Area
          </NewFeedbackAreaText>
        </NewFeedbackAreaButton>
      )}
    </FeedbackAreasWrapper>
  );
};

export default FeedbackAreasDragDrop; 